import * as Types from '../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateThirdPartyInvoiceConfigMutationVariables = Types.Exact<{
  glAccount: Types.Scalars['String'];
}>;


export type UpdateThirdPartyInvoiceConfigMutation = { __typename?: 'MutationModel', thirdPartyInvoices?: { __typename?: 'ThirdPartyInvoicesMutationModel', updateConfig?: { __typename?: 'ValidationResponse', errors?: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string } | null> | null } | null } | null };


export const UpdateThirdPartyInvoiceConfigDocument = gql`
    mutation UpdateThirdPartyInvoiceConfig($glAccount: String!) {
  thirdPartyInvoices {
    updateConfig(glAccount: $glAccount) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type UpdateThirdPartyInvoiceConfigMutationFn = Apollo.MutationFunction<UpdateThirdPartyInvoiceConfigMutation, UpdateThirdPartyInvoiceConfigMutationVariables>;

/**
 * __useUpdateThirdPartyInvoiceConfigMutation__
 *
 * To run a mutation, you first call `useUpdateThirdPartyInvoiceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThirdPartyInvoiceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThirdPartyInvoiceConfigMutation, { data, loading, error }] = useUpdateThirdPartyInvoiceConfigMutation({
 *   variables: {
 *      glAccount: // value for 'glAccount'
 *   },
 * });
 */
export function useUpdateThirdPartyInvoiceConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThirdPartyInvoiceConfigMutation, UpdateThirdPartyInvoiceConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThirdPartyInvoiceConfigMutation, UpdateThirdPartyInvoiceConfigMutationVariables>(UpdateThirdPartyInvoiceConfigDocument, options);
      }
export type UpdateThirdPartyInvoiceConfigMutationHookResult = ReturnType<typeof useUpdateThirdPartyInvoiceConfigMutation>;
export type UpdateThirdPartyInvoiceConfigMutationResult = Apollo.MutationResult<UpdateThirdPartyInvoiceConfigMutation>;
export type UpdateThirdPartyInvoiceConfigMutationOptions = Apollo.BaseMutationOptions<UpdateThirdPartyInvoiceConfigMutation, UpdateThirdPartyInvoiceConfigMutationVariables>;